<template>
    <DsModal
        :is-open="true"
        :title="$t('email.broadcast.unlayer.template.migration.convertEmailDialog.title')"
        size="med"
        show-close
        center
        class="convert-email-dialog-modal"
        @close="closeModal"
    >
        <section class="info">
            <DsInlineAlert
                v-if="conversionError"
                type="critical"
                leading-icon="alert-octagon"
                class="conversion-inline-error"
            >
                <span class="conversion-error-msg">
                    {{ $t('email.broadcast.unlayer.template.migration.convertEmailDialog.errorMessage') }}
                </span>
            </DsInlineAlert>

            <span>
                {{ $t('email.broadcast.unlayer.template.migration.convertEmailDialog.prefix') }}
            </span>

            <DsLink
                external
                :href="$options.LEARN_MORE_LINK"
            >
                {{ $t('email.broadcast.unlayer.template.migration.convertEmailDialog.learnMore') }}
            </DsLink>

            <span>
                {{ $t('email.broadcast.unlayer.template.migration.convertEmailDialog.suffix') }}
            </span>
        </section>

        <section class="actions-container">
            <DsFilledButton
                :loading="isConverting"
                data-qa="convert-email-dialog-confirm-btn"
                @click="confirmDialog"
            >
                {{ $t('email.broadcast.unlayer.template.migration.convertEmailDialog.convertButtonText') }}
            </DsFilledButton>

            <DsTextButton
                :disabled="isConverting"
                @click="closeModal"
            >
                {{ $t('global.cancel') }}
            </DsTextButton>
        </section>
    </DsModal>
</template>

<script>
import {
    migrateTemplateToUnlayer,
} from '@/components/funnel/konva-campaign-editor/elements/thens/communications/unlayerEmail/unlayer.email.api';
import { ConvertBardHtmlToUnlayerJson, ConvertBardToUnlayer } from '@infusionsoft/legacy-email-template-converter';
import { TEMPLATE_MIGRATION_LEARN_MORE_URL as LEARN_MORE_LINK } from '@/components/broadcast/constants/emailBroadcast.constants';

export default {
    LEARN_MORE_LINK,

    name: 'ConvertBardEmailDialog',

    props: {
        design: {
            type: String,
            required: false,
        },

        html: String,
    },

    emits: ['close', 'converted'],

    data() {
        return {
            isConverting: false,
            conversionError: false,
        };
    },

    methods: {
        closeModal() {
            this.$emit('close');
        },

        async confirmDialog() {
            this.isConverting = true;
            this.conversionError = false;

            try {
                let unlayerDesign;

                if (this.design) {
                    unlayerDesign = ConvertBardToUnlayer(JSON.parse(this.design));
                } else {
                    unlayerDesign = ConvertBardHtmlToUnlayerJson(this.html);
                }

                const { design } = await migrateTemplateToUnlayer(unlayerDesign);

                this.$emit('converted', { design });
            } catch (e) {
                this.conversionError = true;
            } finally {
                this.isConverting = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.convert-email-dialog-modal {
    --modal-width: 27.5rem;
    --modal-padding: 1rem 2.25rem;
}

.convert-email-dialog-modal ::v-deep {
    .modal-content-wrapper {
        border-radius: 0.75rem !important;
    }

    .modal-header {
        border-top-left-radius: 0.75rem !important;
        border-top-right-radius: 0.75rem !important;
    }

    .modal-body {
        border-bottom-left-radius: 0.75rem !important;
        border-bottom-right-radius: 0.75rem !important;
    }
}

.conversion-inline-error {
    --icon-size: #{px-to-rem(20px)};
    margin-bottom: $spacing-200;
}

.conversion-error-msg {
    font-size: $font-size-sm;
}

.actions-container {
    display: flex;
    margin: $spacing-300 0 $spacing-100 0;
    gap: $spacing-100;
}

.info {
    font-size: $font-size-md;
    line-height: $line-height-lg;
    color: $color-ink-900;
}

.info span {
    line-height: $line-height-lg;
}
</style>
